import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Carousel, Button, Row, Col, Card } from "react-bootstrap";
import Navbar from "../components/Navbar"; // Reuse your global navbar
import "./HomeNew.css";
const companyData = {
  alphatech: {
    name: "AlphaTech",
    tagline: "Innovating Tomorrow",
    description:
      "AlphaTech is a pioneer in AI-driven solutions, transforming industries with cutting-edge technology.",
    images: ["/assets/ventures.png", "/assets/construction.png"],
    projects: [
      {
        title: "AI Assistant",
        desc: "Conversational AI for enterprise support",
        img: "/assets/infra.png",
      },
      {
        title: "Smart Factory",
        desc: "IoT-powered automation platform",
        img: "/assets/infra.png",
      },
    ],
  },
  // Add other companies here...
};

const CompanyPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const company = companyData[slug];

  if (!company) {
    return (
      <>
        <Navbar />
        <Container className="py-5 text-center">
          <h2>Company not found</h2>
          <Button variant="secondary" onClick={() => navigate("/")}>
            Back to Home
          </Button>
        </Container>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        {/* Hero Section */}
        <Container className="py-5 text-center">
          <h1 className="display-4 fw-bold">{company.name}</h1>
          <p className="lead text-muted">{company.tagline}</p>

          <Carousel className="my-4">
            {company.images.map((img, idx) => (
              <Carousel.Item key={idx}>
                <img
                  className="d-block w-100"
                  src={img}
                  alt={`Slide ${idx + 1}`}
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    borderRadius: "0.75rem",
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>

        {/* Description Section */}
        <Container className="py-4">
          <h3>About {company.name}</h3>
          <p className="text-muted">{company.description}</p>
        </Container>

        {/* Projects Section */}
        <Container className="py-4">
          <h3>Projects</h3>
          <Row xs={1} md={2} className="g-4">
            {company.projects.map((proj, idx) => (
              <Col key={idx}>
                <Card>
                  <Card.Img variant="top" src={proj.img} />
                  <Card.Body>
                    <Card.Title>{proj.title}</Card.Title>
                    <Card.Text>{proj.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>

        {/* Back Button */}
        <Container className="text-center py-4">
          <Button variant="outline-dark" onClick={() => navigate("/")}>
            ← Back to Home
          </Button>
        </Container>
      </div>
    </>
  );
};

export default CompanyPage;
